/**
 * Polyfills for Node.js modules in browser environment
 */

import { Buffer } from 'buffer';

// Make Buffer available globally
if (!globalThis.Buffer) {
  globalThis.Buffer = Buffer;
}

// Ensure process is available
if (!globalThis.process) {
  globalThis.process = {
    env: {},
    browser: true,
    version: '',
    versions: {},
    nextTick: (cb) => setTimeout(cb, 0),
  };
}
